import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Table from "../../Components/Script/Table";
import { getLoansByUser, generatePaymentLink } from "../../Services/loanServices";

function AllLoans() {
    const [loans, setLoans] = useState([]);
    const user = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        fetchLoans();
    }, []);

    const fetchLoans = async () => {
        const data = await getLoansByUser(user.id);
        setLoans(data);
    };

    const handleGeneratePayment = async (loanId) => {
        try {
            await generatePaymentLink(loanId);
            alert("Payment link sent to customer");
            fetchLoans();
        } catch (err) {
            alert("Failed to generate payment link");
        }
    };

    return (
        <>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                         
                        <div className="container-fluid">

                            {/* PAGE TITLE */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">Loan Applications</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">Loan Applications</h4>
                                    </div>
                                </div>
                            </div>

                            {/* TABLE */}
                            <div className="card">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Full Name</th>
                                                    <th>Mobile</th>
                                                    <th>Email</th>
                                                    <th>Loan Type</th>
                                                    {/* <th>Status</th> */}
                                                    <th>Payment</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loans.length > 0 ? (
                                                    loans.map((loan) => (
                                                        <tr key={loan.id}>
                                                            <td>
                                                                {new Date(loan.createdAt).toLocaleDateString("en-GB")}
                                                            </td>
                                                            <td>{loan.fullName}</td>
                                                            <td>{loan.mobile}</td>
                                                            <td>{loan.email}</td>
                                                            <td>{loan.loanType}</td>
                                                            {/* <td>{loan.paymentStatus}</td> */}
                                                            <td>
    {loan.paymentStatus === "Paid" ? (
        <span className="badge bg-success">Paid</span>
    ) : (
        <span className="badge bg-warning">Unpaid</span>
    )}
</td>

<td>
    {loan.paymentStatus !== "Paid" && (
        <button
            className="btn btn-sm btn-primary"
            onClick={() => handleGeneratePayment(loan.id)}
        >
            Send Payment Link
        </button>
    )}
</td>

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            No Loan Applications Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </>
    );
}

export default AllLoans;
